<template>
  <div class="card">
    <h3>Credit Ratings</h3>
    <div class="table-wrap compact-table-wrapper">
      <table class="compact-table">
        <caption class="sr-only">Credit ratings table</caption>
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Rating</th>
            <th scope="col">Rating Date</th>
            <th scope="col">Last Review</th>
            <th scope="col">CWOL</th>
            <th scope="col">CWOL Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(c,i) in items" :key="i">
            <td>{{ c.deptType || c.type || '-' }}</td>
            <td>{{ c.rating || '-' }}</td>
            <td>{{ c.ratingDate ? (c.ratingDate.isValid() ? c.ratingDate.format('DD-MMM-YYYY') : '-') : '-' }}</td>
            <td>{{ c.lastReviewDate ? (c.lastReviewDate.isValid() ? c.lastReviewDate.format('DD-MMM-YYYY') : '-') : '-' }}</td>
            <td>{{ c.cwol || '-' }}</td>
            <td>{{ c.cwolDate ? (c.cwolDate.isValid() ? c.cwolDate.format('DD-MMM-YYYY') : '-') : '-' }}</td>
          </tr>
          <tr v-if="items.length===0"><td colspan="6" class="empty">No credit ratings</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreditRatings',
  props: { items: { type: Array, default: () => [] } },
};
</script>

<style scoped>
.card{ padding: var(--mobile-card-padding); border-bottom: 1px solid var(--compact-table-border) }
.table-wrap{ overflow-x:auto }
table{ width:100%; border-collapse:collapse; min-width:0; table-layout:auto }
th,td{ border:0; padding:var(--compact-table-cell-padding); font-size:var(--compact-table-font-size) }
.empty{ color:#777; padding:6px 0; text-align:center }
tbody tr{ border-bottom:1px solid var(--compact-table-border) }
tbody tr:nth-child(odd){ background:var(--compact-table-zebra) }
</style>
